import React, { useState, useEffect, createContext, Fragment } from 'react';
import moment from 'moment';
import Helmet from 'react-helmet';
import CircularProgress from '@material-ui/core/CircularProgress';
import RmdashboardCard from '../../components/RmDashboardCard/RmdashboardCard';
const lead_icon = '/images/icons/lead_icon.svg';
const sanction_icon = '/images/icons/sanction_icon.svg';
const disbursement_icon = '/images/icons/disbursement_icon.svg';
const login_icon = '/images/icons/login_icon.svg';
import { getBPCardsData } from '../../common/constants/api';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import { siteTitle } from '../../../data/SiteConfig';
import TopBarFiltersForRm from '../../components/TopbarFiltersForRm/TopbarFiltersForRm';
import RMColumns from '../../components/Table/RMColumnData';
import Table from '../../components/Table/LemsTable';
import { getPBTableDataRM, serachCustomer } from '../../common/constants/api';
import { getFiltersInfo, setFiltersInfo } from '../../common/utils/FiltersInfo';
import { GetLeadStatus, getSourceList } from '../../common/constants/api';
import { addButton as AddButton } from '../../common/components/FloatingButtons/FloatingButtons';
import FloatingOptions from '../../common/components/FloatingOptions/FloatingOptions';
import './RmDashboard.css';
const backBtn_icon = '/images/icons/backBtn_icon.svg';
import { navigate } from 'gatsby';
import ApplicationDashboardMobile from '../../containers/RMDashboard/ApplicationDashboard/ApplicationDashboardMobile';
let icons = [
  { icon: lead_icon },
  { icon: login_icon },
  { icon: sanction_icon },
  { icon: disbursement_icon }
];

let cardStaticData = [
  {
    count: 0,
    status: 'Leads',
    payout: 0,
    amount: 0,
    gr: 0,
    nr: 0
  },
  {
    count: 0,
    status: 'Login',
    payout: 0,
    amount: 0,
    gr: 0,
    nr: 0
  },
  {
    count: 0,
    status: 'Sanctioned',
    payout: 0,
    amount: 0,
    gr: 0,
    nr: 0
  },
  {
    count: 0,
    status: 'Disbursed',
    payout: 0,
    amount: 0,
    gr: 0,
    nr: 0
  }
];
export const StateExporterRm = createContext();

const RmDashboard = () => {
  const url = new URL(window.location.href);
  const getStatus = () => {
    let status = url.searchParams.get('status');
    let statusLS = getFiltersInfo().status;
    if (typeof statusLS == 'object') return '';
    return status || statusLS || '';
  };

  const getStartDate = () =>
    url.searchParams.get('fromDate') ||
    getFiltersInfo()?.startDate ||
    moment().format('YYYY-MM-DD');

  const getEndDate = () =>
    url.searchParams.get('toDate') ||
    getFiltersInfo()?.endDate ||
    moment().format('YYYY-MM-DD');

  const getRmId = () =>
    url.searchParams.get('rm') || getFiltersInfo().rmId || '';

  const getBpUserId = () =>
    url.searchParams.get('bpUserId') || getFiltersInfo().bpUserId || '';

  const getTargetMonth = () => {
    const url = new URL(window.location.href);
    const targetMonth = url.searchParams.get('targetMonth');
    return targetMonth || preFilters?.targetMonth || undefined;
  };

  const [cardData, setCardData] = useState([]);
  const [startDate, setStartDate] = useState(getStartDate());
  const [endDate, setEndDate] = useState(getEndDate());
  const [tableInfo, setTableInfo] = useState({ size: 10 });
  const [tableLoading, setTableLoading] = useState(true);
  const [cardLoading, setCardLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [rmId, setRmId] = useState(getRmId());
  const [bpUserId, setBpUserId] = useState(getBpUserId());
  const [FilterStatus, setFilterStatus] = useState(getStatus());
  const [preFilters, setPreFilters] = useState(getFiltersInfo());
  const [changeMonth, setChangeMonth] = useState(getTargetMonth());
  const [sourceList, setSourceList] = useState([]);
  const [source, setSource] = useState(getFiltersInfo()?.sourceFilter || '');
  const [doRender, setRender] = useState(false);
  const [page, setPage] = useState(false);
  const [serachPara, setSearchPara] = useState('');

  const [disbursedMonth, setDisbursedMonth] = useState(
    getFiltersInfo()?.disbursedMonth || null
  );

  const [resetChangeMonth, setResetChangeMonth] = useState('');
  const [bankId, setBankId] = useState(
    getFiltersInfo()?.backPage && (getFiltersInfo()?.bankFilter?.value || '')
  );
  const [cityId, setCityId] = useState(
    getFiltersInfo()?.backPage && (getFiltersInfo()?.cityFilter?.value || '')
  );

  const onButtonClickHandler = () => {
    setShow(!show);
  };
  const [filterProductType, setFilterProductType] = useState(
    getFiltersInfo()?.productType || null
  );
  const productIdSetter = filterProductType => {
    if (filterProductType === 'Home Loan')
      return setFilterProductId ? setFilterProductId(1) : 1;
    if (filterProductType === 'LAP')
      return setFilterProductId ? setFilterProductId(2) : 2;
    if (filterProductType === 'PL')
      return setFilterProductId ? setFilterProductId(13) : 13;
    if (filterProductType === 'BL')
      return setFilterProductId ? setFilterProductId(12) : 12;
    if (filterProductType === '2  Wheeler Loan')
      return setFilterProductId ? setFilterProductId(14) : 14;
  };
  const [filterProductId, setFilterProductId] = useState(
    getFiltersInfo()?.productId ||
      productIdSetter(getFiltersInfo()?.productType) ||
      ''
  );
  const [backPage, setbackPage] = useState(getFiltersInfo()?.backPage || '');

  useEffect(() => {
    let targetChangeMonth = '';
    let copyCardStaticData = [...cardStaticData];
    setCardLoading(true);
    if (changeMonth !== undefined) {
      if (changeMonth?.year) {
        targetChangeMonth = `${changeMonth?.year}-${changeMonth?.month}-28`;
      } else {
        targetChangeMonth = '';
      }
    }
    getBPCardsData(startDate, endDate, '', targetChangeMonth)
      .then(res => {
        res.forEach((item, index) => {
          const finalDefaultData = copyCardStaticData[index]
            ? copyCardStaticData[index]
            : {};

          const getRidOfNullItems = Object.keys(item).filter(
            each => item[each] !== null
          );

          const objeAfterGettingRidOfNullItems = getRidOfNullItems.reduce(
            (acc, key) => {
              acc[key] = item[key];
              return acc;
            },
            {}
          );
          copyCardStaticData[index] = {
            ...finalDefaultData,
            ...objeAfterGettingRidOfNullItems
          };
        });
        setCardData(copyCardStaticData);

        setCardLoading(false);
      })
      .catch(err => {});
  }, [startDate, endDate, changeMonth]);
  const [TableData, setTableData] = useState([]);
  const [tableDataMobile, seTableDataMObile] = useState([]);

  const getTheApplicantionDetails = () => {
    let targetChangeMonth = '';
    setTableLoading(true);
    if (changeMonth !== undefined) {
      if (changeMonth?.year) {
        targetChangeMonth = `${changeMonth?.year}-${changeMonth?.month}-28`;
      } else {
        targetChangeMonth = '';
      }
    }

    getPBTableDataRM(
      page || 0,
      200,
      startDate,
      endDate,
      'sourcingDate',
      'desc',
      FilterStatus,
      rmId,
      bpUserId,
      targetChangeMonth,
      filterProductId,
      bankId,
      cityId,
      backPage == 'bankDisbursementReport' ? disbursedMonth : '',
      source,
      serachPara
    )
      .then(data => {
        setTableData([...(data?.data || [])]);
        seTableDataMObile([...(data?.data || [])]);

        setTableInfo(data?.dataPage);
        setTableLoading(false);
      })
      .catch(err => {});
  };

  useEffect(() => {
    getTheApplicantionDetails();
  }, [
    startDate,
    endDate,
    rmId,
    bpUserId,
    source,
    FilterStatus,
    filterProductId,
    serachPara,
    page,
    changeMonth
  ]);

  useEffect(() => {
    if (filterProductType === null) return;
    if (filterProductType) {
      productIdSetter(filterProductType);
    } else setFilterProductId('');
  }, [filterProductType]);

  useEffect(() => {
    if (typeof changeMonth == 'undefined') return;
    let filters = getFiltersInfo();
    if (typeof filters == 'object') {
      filters['targetMonth'] = changeMonth;
      setFiltersInfo(filters);
    } else {
      setFiltersInfo({
        targetMonth: changeMonth
      });
    }
  }, [changeMonth]);

  useEffect(() => {
    return () => {
      setChangeMonth(undefined);
      let filtersData = getFiltersInfo();
      if (typeof filtersData == 'object') {
        filtersData['backPage'] = '';
        filtersData['bpUserId'] = '';
        setFiltersInfo(filtersData);
      } else {
        setFiltersInfo({
          backPage: ''
        });
      }
    };
  }, []);

  const getSourceData = () =>
    getSourceList()
      .then(res => {
        if (res?.error) throw new Error(res);
        setSourceList(
          res?.map(each => {
            return {
              htmlTitle: (
                <span className="text-blue-1101">{each?.displayName}</span>
              ),
              title: `${each?.id}`,
              checked:
                getFiltersInfo()?.sourceFilter?.toString() == `${each?.id}`
                  ? true
                  : false
            };
          })
        );
      })
      .catch(error => {});

  useEffect(() => {
    getSourceData();
  }, []);

  const getFilteredData = data => {
    setSource(
      data?.Source &&
        Object?.keys(data?.Source)?.filter(each => data?.Source?.[each])
    );
  };
  useEffect(() => {
    setFiltersInfo({
      ...(getFiltersInfo() || {}),
      sourceFilter: source?.toString()
    });
    setSourceList(
      sourceList?.map(each => {
        return {
          htmlTitle: each?.htmlTitle,
          title: each?.title,
          checked: getFiltersInfo()?.sourceFilter?.toString() == each?.title
        };
      })
    );
  }, [source]);

  useEffect(() => {
    setRender(!doRender);
  }, [sourceList]);
  return (
    <>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />

          {show ? (
            <FloatingOptions
              rm
              show
              clicked={onButtonClickHandler}
              getLeadData={getTheApplicantionDetails}
              setShow={setShow}
            />
          ) : (
            <AddButton clicked={onButtonClickHandler} />
          )}
          <div className="widhtMd max-screen flex-1  w-full ">
            <Header />
            <div className="md:hidden">
              <ApplicationDashboardMobile
                data={TableData}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setSource={setSource}
                setFilterStatus={setFilterStatus}
                setFilterProductId={setFilterProductId}
                setRmId={setRmId}
                tableLoading={tableLoading}
                tableInfo={tableInfo}
                setPage={setPage}
                setSearchPara={setSearchPara}
                getLeadData={getTheApplicantionDetails}
                setTargetMonth={setChangeMonth}
                targetmonth={changeMonth}
              />
            </div>
            <div className=" w-full hidden md:block ">
              <StateExporterRm.Provider
                value={{
                  startDate,
                  setStartDate,
                  endDate,
                  setEndDate,
                  setChangeMonth,
                  changeMonth
                }}
              >
                {backPage && (
                  <div
                    className="ml-4 mt-4 md:mt-0 cursor-pointer mb-5 table"
                    onClick={() => {
                      if (backPage == 'teamReport')
                        navigate('/app/report/teamperformance');
                      else if (backPage == 'bankReport')
                        navigate('/app/report/bankperformance');
                      else if (backPage == 'bankDisbursementReport')
                        navigate('/app/report/bank/disbursement');
                      else if (backPage == 'bp') {
                        navigate('/app/bp');
                      }
                    }}
                  >
                    <img src={backBtn_icon} alt="" />
                  </div>
                )}

                <TopBarFiltersForRm
                  hideAddLeadBtn={true}
                  setChangeMonth={setChangeMonth}
                  changeMonth={changeMonth}
                />
              </StateExporterRm.Provider>

              <div className="test w-full ">
                {!cardLoading ? (
                  <div className="cardsContainer">
                    {cardData.length !== 0 &&
                      cardData.map((each, index) => {
                        return (
                          <RmdashboardCard
                            key={index}
                            sendeach={each}
                            icons={icons[index]}
                          />
                        );
                      })}
                    {!cardData ||
                      (cardData && cardData.length === 0 && (
                        <p className="text-red-300">Something went wrong</p>
                      ))}
                  </div>
                ) : (
                  <div className="w-full mx-auto text-center items-center py-5">
                    <CircularProgress />
                  </div>
                )}
                <Table
                  rm
                  rmId={rmId}
                  setFilterStatus={setFilterStatus}
                  bpUserId={bpUserId}
                  setBpUserId={setBpUserId}
                  setRmId={setRmId}
                  targetMonth={changeMonth}
                  StatusFilter={FilterStatus}
                  Search=""
                  data={TableData ? TableData : []}
                  StatusOPtion={[]}
                  columns={RMColumns}
                  serverPagination
                  serverPaginationUrl={getPBTableDataRM}
                  searchUrl={serachCustomer}
                  TableInfo={tableInfo}
                  startDate={startDate}
                  endDate={endDate}
                  filterProductId={filterProductId}
                  setFilterProductId={setFilterProductId}
                  filterProductType={filterProductType}
                  setFilterProductType={setFilterProductType}
                  tableLoading={tableLoading}
                  filterName="status"
                  searchName="leadId"
                  serchBarPlaceHolder="Search by name , Lead ID or Mobile No"
                  GetLeadStatus={GetLeadStatus}
                  filterImage={false}
                  filterCaption="status"
                  tableListbelongs="Leads"
                  filterComponent
                  labelText="All"
                  serverSort
                  rows="200"
                  bankId={bankId}
                  cityId={cityId}
                  user="rm"
                  disbursedMonth={disbursedMonth}
                  backPage={backPage}
                  extraFilters={
                    sourceList.length > 0
                      ? [
                          {
                            name: 'Source',
                            type: 'check',
                            dropdown: sourceList,
                            singleSelect: true
                          }
                        ]
                      : false
                  }
                  filteredObject={getFilteredData}
                  source={source}
                  render={doRender}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RmDashboard;
